<template>
  <div
    @click="scrollTop()"
    class="hidden btn-scroll-to-top btn-primary cursor-pointer invisible lg:visible z-40"
  >
    nach oben
  </div>
</template>
<script setup lang="ts">
const scrollTop = () => {
  if (import.meta.client) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

const debounce = (fn) => {
  let frame;
  return (...params) => {
    if (frame) {
      cancelAnimationFrame(frame);
    }
    frame = requestAnimationFrame(() => {
      fn(...params);
    });
  };
};

onMounted(() => {
  if (!window.scrollToTopBound) {
    let scrollToTopButtons = document.getElementsByClassName('btn-scroll-to-top');
    const scrollPosition = () => {
      if (window.scrollY > 250) {
        for (let i = 0; i < scrollToTopButtons.length; i++) {
          scrollToTopButtons[i].classList.remove('hidden');
        }
      } else {
        for (let i = 0; i < scrollToTopButtons.length; i++) {
          scrollToTopButtons[i].classList.add('hidden');
        }
      }
    };

    document.addEventListener('scroll', debounce(scrollPosition), { passive: true });
    scrollPosition();
    window.scrollToTopBound = true;
  }
});
</script>
